import CheckIcon from '@mui/icons-material/Check';
import { Box, Button, Card, Typography } from '@mui/material';
import React from 'react';

export const FormEndMEP = ({ data, onSubmit, profile, onClose }) => {
  const handleSubmit = () => {
    const today = new Date();
    const update = {
      code: 'ACTIVE',
      endAt: today,
      author: profile,
      startAt: data?.startAt,
    };
    onSubmit(update);
    onClose(null);
  };

  return (
    <Box
      sx={{
        minHeight: '40rem',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'start',
        gap: 1,
      }}
    >
      <Card
        sx={{
          width: '100%',
          padding: 2,
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Typography
            color="primary"
            sx={{ fontSize: '1em', fontWeight: 'bold' }}
          >
            Finalisation du déploiement
          </Typography>
        </Box>
        <Typography sx={{ fontSize: '1em' }}>
          Détails du déploiement :
        </Typography>
        <Typography>
          <strong>Responsable du déploiement:</strong> {profile.firstName}{' '}
          {profile.lastName}
        </Typography>
        <Typography>
          <strong>Début:</strong>{' '}
          {new Date(data?.scheduledAt).toLocaleString('fr')}
        </Typography>
        <Typography>
          <strong>Fin estimée:</strong>{' '}
          {data?.estimedEndAt
            ? new Date(data?.estimedEndAt).toLocaleString('fr')
            : 'Non renseignée'}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <Button variant="outlined" color="info" onClick={() => onClose(null)}>
            Annuler
          </Button>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              endIcon={<CheckIcon />}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              Finaliser le déploiement
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};
